export default __webpack_public_path__ + "static/media/swiftstrikes9.ca2dafa2.png";